import React from 'react';
import { ReactComponent as ActionProjectIcon } from '../../icons/action-project.svg';
import { ReactComponent as CloseXIcon } from '../../icons/close-x.svg';
import { ReactComponent as CheckmarkIcon } from '../../icons/checkmark.svg';

export interface VoiceCallProjectCardProps {
  id: string;
  projectName: string;
  direction: string;
  status: 'pending' | 'creating' | 'created';
  agentNickname?: string;
  onStartProject: (id: string) => void;
  onRemove: (id: string) => void;
}

const VoiceCallProjectCard: React.FC<VoiceCallProjectCardProps> = ({
  id,
  projectName,
  direction,
  status,
  agentNickname,
  onStartProject,
  onRemove,
}) => {
  const isCreated = status === 'created';
  const isCreating = status === 'creating';

  return (
    <div className={`voice-call-project-card${isCreated ? ' created' : ''}`}>
      {/* Remove button */}
      {!isCreated && (
        <button
          className='voice-project-remove-btn'
          onClick={() => onRemove(id)}
          title='Remove'
        >
          <CloseXIcon />
        </button>
      )}

      {/* Project name */}
      <div className='voice-project-header'>
        <ActionProjectIcon className='voice-project-icon' />
        <span className='voice-project-name'>{projectName}</span>
      </div>

      {/* Direction / briefing summary */}
      <div className='voice-project-direction'>
        <span className='voice-project-direction-text'>{direction}</span>
      </div>

      {/* Footer */}
      <div className='voice-project-footer'>
        <span className='voice-project-label'>
          {agentNickname || 'Secretary'} will start working on this project
        </span>

        <div className='voice-project-actions'>
          {!isCreated && (
            <button
              className='voice-project-start-btn'
              onClick={() => onStartProject(id)}
              disabled={isCreating}
            >
              {isCreating ? 'Starting...' : 'Start Project'}
            </button>
          )}
          {isCreated && (
            <span className='voice-project-created-badge'>
              <CheckmarkIcon /> Started
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default VoiceCallProjectCard;
